/**
 * Client-side mirror of the server-side device circuit breaker.
 *
 * If the server returns deviceSuspended=true on /init, we cache that flag for
 * 24h and operate in events-only-suspended mode (no chunk upload attempts,
 * banner shown, but events still capture so we don't lose forensic data).
 */

interface SuspensionState {
    suspended: boolean;
    until: string | null;
    cachedAt: number;
}

let cached: SuspensionState | null = null;

const CACHE_TTL_MS = 24 * 60 * 60 * 1000;

export const DeviceHealth = {
    record(suspended: boolean, until: string | null): void {
        cached = { suspended, until, cachedAt: Date.now() };
    },

    isSuspended(): boolean {
        if (!cached) {
            return false;
        }
        if (Date.now() - cached.cachedAt > CACHE_TTL_MS) {
            return false;
        }
        if (!cached.suspended) {
            return false;
        }
        if (cached.until && new Date(cached.until).getTime() <= Date.now()) {
            return false;
        }
        return true;
    },

    suspendedUntil(): string | null {
        return cached?.until ?? null;
    },

    /** Test-only reset. */
    _reset(): void {
        cached = null;
    }
};
